<template>
  <div class="relative">
    <ul class="gap-2" :class="[layout, layout === 'grid' ? 'cols-3' : 'wrap']">
      <li v-for="({ id, label }, i) in filter.options" :key="id + i">
        <base-toggle v-model="model" data-test-id="vf-style-filter" :value="id">
          <span
            class="f-col justify-center gap-1 b b-grey-40 rounded-xs p-2 text-center text-xs c-grey-10 duration peer-focus-visible:outline-auto"
            :class="{
              'b-transparent bg-brand-1 ':
                model?.includes?.(id),
            }"
            data-test-id="vf-style-filter"
            :style="{ height, width }"
          >
            <base-picture
              alt=""
              class="aspect-square"
              height="56"
              :src="`/img/tile-images/${id?.toLowerCase().split(' ').join('-')}.svg`"
              width="56"
            />
            <span class="truncate" data-test-id="vf-style-filter-text">
              {{ label }}
            </span>
          </span>
        </base-toggle>
      </li>
    </ul>
    <div v-if="loading" class="absolute-0 bg-white op-50" />
  </div>
</template>

<script lang="ts" setup>
import type { StyleFilter } from '#types/filters'

const { layout = 'flex' } = defineProps<{
  filter: StyleFilter
  layout?: 'flex' | 'grid'
  loading?: boolean
}>()

const { height, width } = useAppConfig().components.filter.option.tileImage

const model = defineModel<string[]>()
</script>
